
.ActionSection {
    padding: 0 0 1rem;
    border: 2px solid transparent;
    border-bottom-color: var(--soniq-t--global--border--color--card--default);
    scroll-margin-top: var(--soniq-t--global--toolbar--height--primary--lg, 65px);
}

.ActionSection__withAttention {
    animation: attention 4s ease-out .2s forwards;
}

.ActionSection__toolbar {
    padding: 0 .5rem;
    border-bottom: solid 1px transparent;
}

.ActionSection__content {
    padding: 0 .5rem;
}

@keyframes attention {
    0% {
        border-color: transparent;
    }
    10% {
        border-color: var(--soniq-t--global--border--color--accent--active--default);
    }
    80% {
        border-color: var(--soniq-t--global--border--color--accent--active--default);
    }
    100% {
        border-color: transparent;
    }
}
